// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/BusinessLocationSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/BusinessLocationSortBy.proto.
 */
export const file_Enumerations_BusinessLocationSortBy: GenFile = /*@__PURE__*/
  fileDesc("CilFbnVtZXJhdGlvbnMvQnVzaW5lc3NMb2NhdGlvblNvcnRCeS5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMqtAMKFkJ1c2luZXNzTG9jYXRpb25Tb3J0QnkSKQolQlVTSU5FU1NfTE9DQVRJT05fU09SVF9CWV9VTlNQRUNJRklFRBAAEi8KI0JVU0lORVNTX0xPQ0FUSU9OX1NPUlRfQllfVEVOQU5UX0lEEAMaBsrHzQ8BAxIxCiVCVVNJTkVTU19MT0NBVElPTl9TT1JUX0JZX0JVU0lORVNTX0lEEAQaBsrHzQ8BBBIzCidCVVNJTkVTU19MT0NBVElPTl9TT1JUX0JZX0JVU0lORVNTX05BTUUQBRoGysfNDwEFEioKHkJVU0lORVNTX0xPQ0FUSU9OX1NPUlRfQllfTkFNRRAGGgbKx80PAQYSMQokQlVTSU5FU1NfTE9DQVRJT05fU09SVF9CWV9DUkVBVEVEX0FUEGQaB8rHzQ8CZAESMgolQlVTSU5FU1NfTE9DQVRJT05fU09SVF9CWV9NT0RJRklFRF9BVBBlGgfKx80PAmQCEjEKJEJVU0lORVNTX0xPQ0FUSU9OX1NPUlRfQllfREVMRVRFRF9BVBBmGgfKx80PAmQDIgQIARABIgQIAhACIgQIBxBjQiiqAiVNb2dpLlRpbWVUcmFja2luZy5Db21tb24uRW51bWVyYXRpb25zYgZwcm90bzM", [file_Options_EnumValueOptions]);

/**
 * Determines by which colums to sort business locations by.
 *
 * @generated from enum time_tracking.enumerations.BusinessLocationSortBy
 */
export enum BusinessLocationSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: BUSINESS_LOCATION_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the business locations by their tenant id.
   *
   * @generated from enum value: BUSINESS_LOCATION_SORT_BY_TENANT_ID = 3;
   */
  TENANT_ID = 3,

  /**
   * Sort the business locations by the GUIDs of the businesses they belong to.
   *
   * @generated from enum value: BUSINESS_LOCATION_SORT_BY_BUSINESS_ID = 4;
   */
  BUSINESS_ID = 4,

  /**
   * Sort the business locations by the names of the businesses they belong to.
   *
   * @generated from enum value: BUSINESS_LOCATION_SORT_BY_BUSINESS_NAME = 5;
   */
  BUSINESS_NAME = 5,

  /**
   * Sort the business locations by their name.
   *
   * @generated from enum value: BUSINESS_LOCATION_SORT_BY_NAME = 6;
   */
  NAME = 6,

  /**
   * Sort the business locations by their creation time stamp.
   *
   * @generated from enum value: BUSINESS_LOCATION_SORT_BY_CREATED_AT = 100;
   */
  CREATED_AT = 100,

  /**
   * Sort the business locations by their modification time stamp.
   *
   * @generated from enum value: BUSINESS_LOCATION_SORT_BY_MODIFIED_AT = 101;
   */
  MODIFIED_AT = 101,

  /**
   * Sort the business locations by their deletion time stamp.
   *
   * @generated from enum value: BUSINESS_LOCATION_SORT_BY_DELETED_AT = 102;
   */
  DELETED_AT = 102,
}

/**
 * Describes the enum time_tracking.enumerations.BusinessLocationSortBy.
 */
export const BusinessLocationSortBySchema: GenEnum<BusinessLocationSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_BusinessLocationSortBy, 0);

